export default __webpack_public_path__ + "static/media/img-tests-passed.73d0f642.svg";